import { jsx as _jsx } from "react/jsx-runtime";
import './Attribution.scss';
export const Attribution = ({ children }) => {
    return _jsx("span", { className: 'rpx-attribution', children: children });
};
//# sourceMappingURL=Attribution.js.map